import React, { ReactElement } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ErrorPage } from "./pages";
import { history } from "./services/history";
import { useModal } from "./hooks/useModal";
import CustomHistoryRouter from "./routes/CustomHistoryRouter";
import AppRoutes from "./routes/Router";
import { store } from "./redux/store";
import { CookiePopup } from "./components/CookiePopup";
import { COOKIE_OPEN } from "./constants/cookiesKeys";
import { useMetaPixel } from "./hooks/useMetaPixel";

function App(): ReactElement {
  useMetaPixel();
  const cookieModal = useModal(true, COOKIE_OPEN);

  return (
    <HelmetProvider>
      <CustomHistoryRouter history={history}>
        <ReduxProvider store={store}>
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <div className="App flex flex-col overflow-x-hidden">
              <AppRoutes />
              <ToastContainer
                position="bottom-right"
                theme="light"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                rtl={false}
                transition={Bounce}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <CookiePopup {...cookieModal} />
            </div>
          </ErrorBoundary>
        </ReduxProvider>
      </CustomHistoryRouter>
    </HelmetProvider>
  );
}

export default App;
